import {useNavigate} from 'react-router'
import {Button} from 'brand/Button'

import camera from './icon-camera-lowlight.svg'

export const SelfiePreview = ({selfieData}) => {
  const nav = useNavigate()

  const back = () => nav('/consult/selfie/camera')
  const forward = () => nav('/consult/questionnaire')

  return (
    <div className="column">
      <section className="page-title">
        <div className="heading size-s">Photo upload</div>
      </section>
      <div className="heading size-xxxl">Thanks, beautiful</div>
      <section className="intro">
        <div className="content size-l">
          We'll use this to model your new look in the next step.
        </div>
      </section>
      <section>
        <div className="content column">
          <img className="selfie-preview selfie-tile" src={selfieData} alt="Selfie" />
          <Button tone="lowlight" action={back}>
            <img src={camera} alt="Camera icon" /> Retake my photo
          </Button>
        </div>
      </section>
      <section className="float-bottom">
        <div className="content">
          <Button size="large" action={forward}>Next</Button>
        </div>
      </section>
    </div>
  )
}
